import {arrow, computePosition, flip, offset} from "@floating-ui/dom";

export function addShareIconListeners() {
    document.querySelectorAll('.js--share-icon').forEach(function (elem) {
        elem.addEventListener('click', function (e) {
            e.preventDefault();

            const floating = e.target.closest('.shared').querySelector('.shared_block')
            const arrowNode = floating.querySelector('.js--arrow')
            if (floating.classList.contains('hidden')) {
                floating.classList.remove('hidden')
                computePosition(e.target.closest('.shared'), floating, {
                    placement: 'bottom-end',
                    middleware: [flip(), offset(4), arrow({element: arrowNode})]
                }).then(({x, y, middlewareData, placement}) => {
                    Object.assign(floating.style, {
                        left: `${x}px`,
                        top: `${y}px`,
                    })

                    if (middlewareData.arrow) {
                        const {x} = middlewareData.arrow;
                        const isFlipped = placement.startsWith('top');

                        Object.assign(arrowNode.style, {
                            left: `${x}px`,
                            top: isFlipped ? 'auto' : `${-arrowNode.offsetHeight / 2}px`,
                            bottom: isFlipped ? `${-arrowNode.offsetHeight / 2}px` : 'auto',
                            // transform: isFlipped ? 'rotate(180deg)' : 'rotate(0deg)'
                        });
                    }
                })
            } else {
                floating.classList.add('hidden')
                floating.style.left = '0'
                floating.style.top = '0'
            }
        })
    })
}